import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AppLayout from "./pages/AppLayout";
import Dashboard from "./pages/Dashboard";
import Convert from "./pages/Convert";
import CompanyProfile from "./pages/CompanyProfile";
import AdminUsers from "./pages/AdminUsers";
import AcceptInvite from "./pages/AcceptInvite";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Lade...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Lade...</div>;
  if (user) return <Navigate to="/app/convert" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Lade...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/app/convert" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/app/convert" replace/>}/>
          <Route path="/login" element={<PublicOnly><Login/></PublicOnly>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/accept-invite" element={<AcceptInvite/>}/>
          <Route path="/app" element={<Protected><AppLayout/></Protected>}>
            <Route index element={<Navigate to="convert" replace/>}/>
            <Route path="convert" element={<Convert/>}/>
            <Route path="dashboard" element={<Dashboard/>}/>
            <Route path="profile" element={<CompanyProfile/>}/>
            <Route path="admin/users" element={<AdminOnly><AdminUsers/></AdminOnly>}/>
          </Route>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
